import { render, staticRenderFns } from "./TipoTrabajoPage.vue?vue&type=template&id=df5758d6"
import script from "./TipoTrabajoPage.js?vue&type=script&lang=js&external"
export * from "./TipoTrabajoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports